import * as agendaActions from './actions';

import { DetailsAgendaActionTypes, DetailsAgendaState } from './types';

import { ActionType } from 'typesafe-actions';
import { DateTime } from 'luxon';
import { Reducer } from 'redux';
import { AgendaHistoryAudit } from './model';

export type AgendaAction = ActionType<typeof agendaActions>;

const initialState: DetailsAgendaState = {
  selectedHistoryId: 0,
  plannedOnDate: '',
  plannedOnTime: '',
  agendaReference: '',
  status: '',
  agendaHistoryAuditList: []
};

const reducer: Reducer<DetailsAgendaState, AgendaAction> = (state = initialState, action): DetailsAgendaState => {
  switch (action.type) {
    case DetailsAgendaActionTypes.FETCH_AGENDA_SUCCESS: {
      const plannedOnDate = action.payload.plannedOnDate
        ? action.payload.plannedOnDate instanceof Date
          ? action.payload.plannedOnDate.toISOString() 
          : action.payload.plannedOnDate
        : '';
      const plannedOnTime = action.payload.plannedOnDate
        ? action.payload.plannedOnDate instanceof Date
          ? DateTime.fromJSDate(action.payload.plannedOnDate).toFormat('HH:mm') // Handle Date object
          : DateTime.fromISO(action.payload.plannedOnDate).toFormat('HH:mm') // Handle ISO string
        : '';
      const agendaReference = action.payload.agendaReference || '';
      const status = action.payload.status || '';
      const agendaHistoryAuditList = [...(action.payload.agendaHistoryAuditList || [])].sort(
        (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
      );
      return {
        ...state,
        agendaReference,
        plannedOnDate,
        plannedOnTime,
        agendaHistoryAuditList,
        status,
        selectedHistoryId: 0,
      };
    }
    case DetailsAgendaActionTypes.USE_AGENDA_FROM_HISTORY: {
      const agendaFromHistory: AgendaHistoryAudit | undefined = state.agendaHistoryAuditList.find(
        p => p.agendaHistoryAuditId === action.payload.agendaHistoryAuditId
      );

      if (!agendaFromHistory) {
        return state;
      }

      const plannedOnDate = agendaFromHistory.plannedOnDate
        ? agendaFromHistory.plannedOnDate instanceof Date
          ? agendaFromHistory.plannedOnDate.toISOString() 
          : agendaFromHistory.plannedOnDate 
        : '';
      const plannedOnTime = agendaFromHistory.plannedOnDate
        ? agendaFromHistory.plannedOnDate instanceof Date
          ? DateTime.fromJSDate(agendaFromHistory.plannedOnDate).toFormat('HH:mm') // Handle Date object
          : DateTime.fromISO(agendaFromHistory.plannedOnDate).toFormat('HH:mm') // Handle ISO string
        : '';
      const agendaReference = agendaFromHistory.agendaReference || '';
      const status = agendaFromHistory.status || '';

      return {
        ...state,
        agendaReference,
        plannedOnDate,
        plannedOnTime,
        status,
        selectedHistoryId: agendaFromHistory.agendaHistoryAuditId,
      };
    }
    case DetailsAgendaActionTypes.RESET_HISTORY_SELECTION: {
      const actualAgendaFromHistory = state.agendaHistoryAuditList.length ? state.agendaHistoryAuditList[0] : null;
      if (!actualAgendaFromHistory) {
        return state;
      }

      const plannedOnDate = actualAgendaFromHistory.plannedOnDate
        ? actualAgendaFromHistory.plannedOnDate instanceof Date
          ? actualAgendaFromHistory.plannedOnDate.toISOString() 
          : actualAgendaFromHistory.plannedOnDate
        : '';
      const plannedOnTime = actualAgendaFromHistory.plannedOnDate
        ? actualAgendaFromHistory.plannedOnDate instanceof Date
          ? DateTime.fromJSDate(actualAgendaFromHistory.plannedOnDate).toFormat('HH:mm') // Handle Date object
          : DateTime.fromISO(actualAgendaFromHistory.plannedOnDate).toFormat('HH:mm') // Handle ISO string
        : '';
      const agendaReference = actualAgendaFromHistory.agendaReference || '';
      const status = actualAgendaFromHistory.status || '';

      return {
        ...state,
        agendaReference,
        plannedOnDate,
        plannedOnTime,
        status,
        selectedHistoryId: 0,
      };
    }
    case DetailsAgendaActionTypes.UPDATE_AGENDA_STATE: {
      return { ...state, ...action.payload };
    }
    case DetailsAgendaActionTypes.UPDATE_AGENDA: {
      return { ...state };
    }
    default: {
      return state;
    }
  }
};

export { reducer as detailsAgendaReducer, initialState as detailsAgendaInitialState };
